/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 10:19:12 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Filter, ReferenceInput, SelectInput, useTranslate } from 'react-admin';
import { filterStyle } from 'styles';

const ProjectFilters = ({ organisationFilter, ...props }) => {
  const translate = useTranslate();
  const classes = filterStyle();

  return (
    <Filter className={classes.root} {...props}>
      <ReferenceInput
        label="resources.Project.fields.organisation"
        source="organisationId"
        reference="Organisation"
        emptyText={translate('resources.Project.noOrganisations')}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={organisationFilter}
        alwaysOn
      >
        <SelectInput
          source="id"
          optionText="name"
          options={{
            InputLabelProps: { shrink: true },
            SelectProps: { displayEmpty: true },
          }}
        />
      </ReferenceInput>
    </Filter>
  );
};

export default ProjectFilters;
